import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ShopApiService } from '@digilize/shared/data/services/src';
import { ShopService } from '@digilize/shared/data/state-services/src';
import { Shop } from '@digilize/shared/definitions/src';
import { filter, first, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'lib-dark-theme-navbar-shop-select',
  templateUrl: './dark-theme-navbar-shop-select.component.html',
  styleUrls: ['./dark-theme-navbar-shop-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SchedularShopSelectComponent implements OnInit, OnDestroy {
  // @Output() valueChange = new EventEmitter<string>();
  // @Input() options: SelectionOption[] = [];
  // @Input() value: string;
  // @Input() defaultShop: Shop;
  @Input() customClass: string;
  @Input() exitOption = false;
  opened = false;
  destroy$ = new Subject<void>();

  companyShopsOptions;
  activeShop: Shop;

  constructor(
    private shopApiService: ShopApiService,
    private shopService: ShopService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.getShops();
    this.shopService
      .getActiveShop()
      .pipe(takeUntil(this.destroy$))
      .subscribe((activeShop) => {
        if (activeShop) {
          this.activeShop = activeShop;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getShops() {
    this.shopService.companyShops$
      .pipe(
        filter((shops) => !!shops),
        first()
      )
      .subscribe((shops) => {
        const activeShops = shops.filter((shop) => shop.active);
        this.companyShopsOptions = activeShops.map((shop) => ({ key: shop.name, value: shop.id }));
      });
  }

  selectShop(shopId: string) {
    localStorage.setItem('lastSelectedShopId', shopId);
    const shop = this.shopService.companyShops.find((shop) => shop.id === shopId);
    this.shopService.setActiveShop(shop);
    this.opened = false;
  }

  toggleSelect() {
    this.opened = !this.opened;
  }

  exit() {
    setTimeout(() => {
      sessionStorage.removeItem('recentTagsAndProductsActiveDate');
      sessionStorage.removeItem('recentSchedularActiveDate');
    }, 500);
    this.router.navigate(['../'], { relativeTo: this.route });
  }
}
